const Text = ({classes=null,text}:any) => {
  return (
    <p className={`text-gray-700 text-sm ${classes}`}>{text}</p>
  )
}

export default Text